var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Stack } from "native-base";
import CardHeader from "./CardHeader";
import CardFooter from "./CardFooter";
const Card = (_a) => {
    var { header, _header, footer, _footer, _content, children } = _a, rest = __rest(_a, ["header", "_header", "footer", "_footer", "_content", "children"]);
    return (_jsxs(Stack, Object.assign({ direction: "column", justifyContent: "space-between", overflow: "hidden", borderRadius: "lg", borderColor: "gray.100", borderWidth: 1, borderStyle: "solid", bgColor: "white", flex: 1, px: 4, py: 4 }, rest, { children: [header && _jsx(CardHeader, Object.assign({}, _header, { children: header })), _jsx(Box, Object.assign({ flex: 1 }, _content, { children: children })), footer && _jsx(CardFooter, Object.assign({}, _footer, { children: footer }))] })));
};
export default Card;
